var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 249,
    height: 249,
    viewBox: "0 0 249 249",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons-big/success"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 123.949,
    cy: 123.949,
    r: 111.33,
    transform: "rotate(-90 123.949 123.949)",
    stroke: "#6EC85C"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval Copy 2",
    opacity: 0.2,
    cx: 124.5,
    cy: 124.5,
    r: 124,
    transform: "rotate(-90 124.5 124.5)",
    stroke: "#6EC85C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 10970"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval Copy",
    opacity: 0.2,
    cx: 124.5,
    cy: 124.5,
    r: 76.0221,
    transform: "rotate(-90 124.5 124.5)",
    fill: "#6EC85C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icons/status/done"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M119.864 136.295L109.841 126.273L106.5 129.614L119.864 142.977L148.5 114.341L145.159 111L119.864 136.295Z",
    fill: "#6EC85C"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.93beac5fe49b352cc272bfcc4845b2bc.svg";
export { ForwardRef as ReactComponent };